import * as yup from 'yup';

import Steps from '@pages/flexControls/createFlexControl/enums';
import BasicDetailsSchema from '@pages/flexControls/shared/BasicDetailsSchema';
import ConditionsSchema from '@pages/flexControls/shared/ConditionsSchema';
import ResetPeriodSchema from '@pages/flexControls/shared/ResetPeriodSchema';

const CreateFlexControlSchema = {
    [Steps.BasicDetails]: yup.object({ ...BasicDetailsSchema }),
    [Steps.ResetPeriod]: yup.object({ ...ResetPeriodSchema }),
    [Steps.Conditions]: yup.object({ ...ConditionsSchema }),
};

export default CreateFlexControlSchema;
